document.addEventListener('DOMContentLoaded', () => {
	const els = document.querySelectorAll('.orla-animated-paragraph');

	const obs = new IntersectionObserver(
		(entries) => {
			entries.forEach((e) => {
				if (e.isIntersecting) {
					e.target.classList.add('animate');
					obs.unobserve(e.target);
				}
			});
		},
		{ threshold: 0.3 }
	);

	els.forEach((el) => {
		const rect = el.getBoundingClientRect();

		// If already in viewport → show immediately
		if (rect.top < window.innerHeight) {
			el.classList.add('animate');
		} else {
			obs.observe(el);
		}
	});
});
